/**
 * @author emil.ohman@svenskaspel.se (Emil Öhman)
 */

import PropTypes from 'prop-types';
import './../../stylesheets/navigation-indicator.less';

const NavigationIndicator = ({
  className,
  children,
  branding,
  ...props
}) => {
  const classes = ['navigation-indicator'];

  if (className) {
    classes.push(className);
  }

  if (branding) {
    classes.push(`navigation-indicator-${branding}`);
  } else {
    classes.push('navigation-indicator-default');
  }

  return (
    <div
      className={classes.join(' ')}
      role="navigation"
      {...props}
    >
      {children}
    </div>
  );
};

NavigationIndicator.propTypes = {
  /**
   * Set branding
   */
  branding: PropTypes.string,
  /**
   * Content
   */
  children: PropTypes.node,
  /**
   * Add custom class
   */
  className: PropTypes.string
};

export default NavigationIndicator;
